import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import App from './App';
import { getInitialLocale } from './common/utils/helpers';
import AppToastContainer from './common/components/AppToastContainer';
import 'flag-icons/css/flag-icons.min.css';

// @ts-ignore
import messagesEs from './translations/es.json';
// @ts-ignore
import messagesEn from './translations/en.json';

const messages = {
  es: messagesEs,
  en: messagesEn
};

const appContainer = document.getElementById('root');

const root = createRoot(appContainer as HTMLElement);

function Wrapper() {
  const [locale, setLocale] = useState<string>(getInitialLocale());
  return (
    <>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <IntlProvider locale={locale} messages={messages[locale as 'es' | 'en']} defaultLocale="en">
          <App setLocale={setLocale} locale={locale} />
        </IntlProvider>
      </BrowserRouter>
      <AppToastContainer />
    </>
  );
}

root.render(<Wrapper />);
